import classNames from "classnames"
import { Field } from "formik"

import Icon, { IconName } from "@components/common/Icon"
import { useTooltip } from "@services/tooltipHook"

interface IProps {
  className?: string
  chosen: boolean
  icon: IconName
  iconSize?: number
  name: string
  text?: string
  tooltipText?: string
  value: string | number
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void
}

/**
 * This component provides an Icon as formik radio field
 */
const IconRadioField: React.FC<IProps> = (props: IProps) => {
  const {
    className = "radio-icon",
    name,
    chosen,
    setFieldValue,
    icon,
    iconSize = 24,
    text = "",
    tooltipText = "",
    value
  } = props

  const { tooltipTargetRef, ToolTip } = useTooltip(tooltipText)

  const onEnter = (event: React.KeyboardEvent<HTMLElement>) => {
    if (event.key === "Enter") {
      setFieldValue(name, value)
      event.preventDefault()
    }
  }

  const finalClassName = classNames(
    className,
    "clickable",
    { "radio-icon--chosen": chosen },
  )

  return <>
    <span
      className={finalClassName}
      tabIndex={0}
      aria-label={tooltipText}
      onKeyDown={(event) => onEnter(event)}
      onClick={() => setFieldValue(name, value)}
      ref={tooltipTargetRef}
    >
      <Icon name={icon} size={iconSize} />
      {text}

      <Field
        type="radio"
        // must be hidden, otherwise a small radio button dot is visible
        hidden
        name={name}
        value={value}
      />
    </span>
    {ToolTip}
  </>
}

export default IconRadioField
